import React, { useState } from 'react';
import Introduction from './components/Introduction';
import Questionnaire from './components/Questionnaire';

function App() {
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);

  return (
    <div className="min-h-screen bg-white-50">
      {!showQuestionnaire ? (
        <Introduction onStart={() => setShowQuestionnaire(true)} />
      ) : (
        <div className="container mx-auto py-8">
          <h1 className="text-2xl font-bold text-center mb-8">
            
          </h1>
          <Questionnaire />
        </div>
      )}
    </div>
  );
}

export default App; 